export enum TColors {
  YELLOW = 'yellow',
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
  ORANGE = 'orange',
  INDIGO = 'indigo',
  WHITE = 'white',
}
